import { useEffect, useState } from "react";
import { Download, X, Sparkles } from "lucide-react";

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("eyw_install_dismissed");
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      if (!dismissed) setShow(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
    setShow(false);
  };

  const dismiss = () => {
    localStorage.setItem("eyw_install_dismissed", "1");
    setShow(false);
  };

  if (!show || !deferred) return null;

  return (
    <div data-testid="pwa-install-prompt" className="fixed bottom-5 left-1/2 -translate-x-1/2 z-[120] w-[92%] max-w-md">
      <div className="flex items-center gap-3 rounded-2xl bg-[#144F75] text-white shadow-2xl px-4 py-3.5 eyw-reveal">
        <span className="grid place-items-center h-10 w-10 rounded-xl bg-white/15 shrink-0"><Sparkles size={18} /></span>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold leading-tight">Install Enhancing Your World</p>
          <p className="text-xs text-white/70 leading-tight">Add to your home screen for a full-screen, app-like experience.</p>
        </div>
        <button data-testid="pwa-install-btn" onClick={install} className="inline-flex items-center gap-1.5 rounded-full bg-white text-[#144F75] text-sm font-semibold px-4 py-2 shrink-0 hover:bg-white/90 transition-colors">
          <Download size={15} /> Install
        </button>
        <button data-testid="pwa-install-dismiss" onClick={dismiss} className="text-white/70 hover:text-white shrink-0"><X size={18} /></button>
      </div>
    </div>
  );
}
